import { parseDate } from "./Tender";

export interface ListingCoupon {
	Code: string;
	Amount: number;
	Enabled: boolean;
	CreatedByUserId: string;
	DateCreatedUtc: Date;
	PercentageDiscount: number | null;
	RedemptionCount: number | null;
	UsageLimit: number | null;
	Type: string | null;
	ExpirationDateUtc: Date | null;
	RedeemedUserId: string | null;
	DateRedeemedUtc: Date | null;
	ListingId: number | null;
}

export class EditListingCouponModel {
	public Code: string;
	public ListingId: number | null;
	public PercentageDiscount: number | null;
	public Amount: number;
	public Enabled: boolean;
	public Type: string;
	public ExpirationDateUtc: Date | null;
	public RedemptionCount: number | null;
	public UsageLimit: number | null;
	constructor(ListingCoupon?: ListingCoupon) {
		this.Code = ListingCoupon && ListingCoupon.Code;
		this.PercentageDiscount = ListingCoupon && ListingCoupon.PercentageDiscount;
		this.Amount = ListingCoupon && ListingCoupon.Amount;
		this.Enabled = ListingCoupon && ListingCoupon.Enabled;
		this.Type = ListingCoupon && ListingCoupon.Type;
		this.ExpirationDateUtc = ListingCoupon.ExpirationDateUtc ? parseDate(ListingCoupon.ExpirationDateUtc.toString()) : null;
		this.RedemptionCount = ListingCoupon && ListingCoupon.RedemptionCount;
		this.UsageLimit = ListingCoupon && ListingCoupon.UsageLimit;
		this.ListingId = ListingCoupon && ListingCoupon.ListingId;
	}
}

export class CreateListingCouponModel {
	public Code: string;
	public Amount: number;
	public Enabled: boolean;
	public PercentageDiscount: number | null;
	public UsageLimit: number | null;
	public Type: string | null;
	public ExpirationDateUtc: Date | null;
}

export class RedeemResponse {
	public Success: boolean;
	public DiscountMultiplier: number;
	public Error: string;
}

export enum ListingCouponType {
	Fixed = 1,
	Percentage = 2
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/ListingCoupon.ts